import React from "react";
import { Link } from "react-router-dom";
import { Breathing, Image } from "react-shimmer";
import { placeHolderImage } from "../EventCard";

const AthleteShortSummary = (props) => {
  return (
    <li>
      <div className="eventVisitorFull ">
        <div className="one">
          {props.ath.customUrl ? (
            <Link to={`/athletes/${props.ath.customUrl}`} target="_blank">
              <Image
                fallback={<Breathing width={400} height={300} />}
                src={
                  props.ath.thumbnail && props.ath.thumbnail !== "None"
                    ? props.ath.thumbnail
                    : props.ath.thumbnailUrl || placeHolderImage
                }
                alt="images"
              />
            </Link>
          ) : (
            <Image
              fallback={<Breathing width={400} height={300} />}
              src={
                props.ath.thumbnail && props.ath.thumbnail !== "None"
                  ? props.ath.thumbnail
                  : props.ath.thumbnailUrl || placeHolderImage
              }
              alt="images"
            />
          )}
        </div>
        <div class="two">
          {props.ath.customUrl ? (
            <Link to={`/athletes/${props.ath.customUrl}`}>
              <p>{`${props.ath.firstName} ${props.ath.lastName}`}</p>
            </Link>
          ) : (
            <p>{props.ath?.name}</p>
          )}
        </div>
      </div>
    </li>
  );
};

export default AthleteShortSummary;
